<template>
    <div class="text-center">We are disabeling this integration, you will be notified as soon as it's done</div>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// pendingDeactivation.vue?edd236a4